import { render, staticRenderFns } from "./CategoryAmbience.vue?vue&type=template&id=0b89d046"
import script from "./CategoryAmbience.vue?vue&type=script&lang=js"
export * from "./CategoryAmbience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b89d046')) {
      api.createRecord('0b89d046', component.options)
    } else {
      api.reload('0b89d046', component.options)
    }
    module.hot.accept("./CategoryAmbience.vue?vue&type=template&id=0b89d046", function () {
      api.rerender('0b89d046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/CategoryAmbience.vue"
export default component.exports